import { FC, ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./style.module.scss";
import classNames from "classnames";
import { CgSpinner } from "react-icons/cg";

interface MonoButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  size?: "small" | "medium" | "large";
  label: string;
  disabled?: boolean;
  iconLeft?: ReactNode;
  className?: string;
  loading?: boolean;
}

const MonoButton: FC<MonoButtonProps> = ({
  variant = "primary",
  size = "medium",
  className,
  label,
  disabled,
  iconLeft,
  loading,
  ...props
}) => {
  const buttonClass = classNames(className, styles.button, {
    [styles.primary]: variant === "primary",
    [styles.secondary]: variant === "secondary",
    [styles.ghost]: variant === "ghost",
    [styles.disabled]: disabled,
    [styles.small]: size === "small",
    [styles.medium]: size === "medium",
    [styles.large]: size === "large",
  });

  return (
    <button className={buttonClass} {...props} disabled={disabled}>
      {loading ? (
        <div className={styles.spinner}>
          <CgSpinner />
        </div>
      ) : (
        <>
          {iconLeft && <span className="iconLeft">{iconLeft}</span>}
          {label}
        </>
      )}
    </button>
  );
};

export default MonoButton;
